import { NextArrow, PrevArrow } from '../Shared';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import SlickSlider from "react-slick";

export default class Slider extends Component {
    constructor(props) {
        super(props);

        this.state = {

        };
    }
        
    render() {
        
        const { autoplay, fullwidth, slides } = this.props.data;
        
        return (
            <div>
                {
                    !_.isEmpty(slides.data) &&
                    <SlickSlider {...{
                        autoplay: autoplay,
                        className: fullwidth ? "slick-carousel-fullwidth" : "slick-carousel",
                        initialSlide: 0,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        prevArrow: <PrevArrow top={"50%"} left={"50px"} />,
                        nextArrow: <NextArrow top={"50%"} right={"50px"} />,
                        responsive: [
                            {
                                breakpoint: 1200,
                                settings: {
                                }
                            },
                            {
                                breakpoint: 1024,
                                settings: {
                                    arrows: false
                                }
                            },
                            {
                                breakpoint: 768,
                                settings: {
                                    arrows: false
                                }
                            }
                        ]
                    }}>
                        {
                            slides.data.map((slide, key) => {

                                return (
                                    <div key={key}>
                                        {
                                            !_.isEmpty(slide.content) &&
                                            <div dangerouslySetInnerHTML={{__html: slide.content}} />
                                        }
                                    </div>
                                )
                            })
                        }
                    </SlickSlider>
                }
            </div>
        );
    }
}

if (document.getElementById('slider')) {
    
    const element = document.getElementById('slider');
    const data = Object.assign({}, element.dataset);
        
    //console.log(data.data);
    
    ReactDOM.render(<Slider data={JSON.parse(data.data)} />, document.getElementById('slider'));
}



// WEBPACK FOOTER //
// ./resources/js/components/Shortcodes/Slider.js